<template>
  <div class="lm-container">
    <div class="lm-headline">
      <div>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Datasets') }}</span>
        <span>{{ $t('Webportal.CX.Total') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Still') }}</span>
        <span>{{ $t('Webportal.CX.Dashboard.ActionManagementCenter.Open') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Closed') }}</span>
        <span>{{ $t('Webportal.CX.Datasets') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Positive') }}</span>
        <span>{{ $t('Webportal.CX.Rating') }} {{ $t('Webportal.CX.for') }}</span>
        <span>{{ $t('Webportal.CX.Dealer') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Closed') }} {{ $t('Webportal.CX.without') }}</span>
        <span>{{ $t('Webportal.CX.Interview') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Dealer') }} {{ $t('Webportal.CX.has') }}</span>
        <span>{{ $t('Webportal.Dashboard.Lead') }}</span>
        <span>{{ $t('Webportal.CX.Contacted') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.FulfillmentDegree') }}</span>
        <span>{{ $t('Webportal.CX.has') }} {{ $t('Webportal.CX.real') }}</span>
        <span>{{ $t('Webportal.CX.Requests') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Margin') }}</span>
        <span>(%)</span>
      </div>
      <div>
        <span>{{ $t('Webportal.CX.Interview') }} {{ $t('Webportal.CX.guided') }}:</span>
        <span>{{ $t('Webportal.CX.DealerContact') }} {{ $t('Webportal.CX.has') }}</span>
        <span>{{ $t('Webportal.CX.DidNotTakePlace') }}</span>
      </div>
      <div>
        <span>{{ $t('Webportal.Dashboard.Reminder') }}-</span>
        <span>{{ $t('Webportal.CX.EmailsDeadline1') }}</span>
        <span>{{ $t('Webportal.CX.EmailsDeadline2') }}</span>
      </div>
    </div>

    <div class="lm-line" v-for="(val, index) in getValue()" :key="index">
      <div>{{ mode === 'quarterly' ? `Q${val.Quarter}` : getMonthText(val.Month, true) }}</div>
      <div>{{ val.TotalDataSets }}</div>
      <div>{{ val.OpenDataSets }}</div>
      <div>{{ val.ClosedDataSets }}</div>
      <div>{{ val.PositiveRatings }}</div>
      <div>{{ val.ClosedWithoutInterview }}</div>
      <div>{{ val.ContactedLeads }}</div>
      <div :style="getThresholdStyle(val.FullfillmentRate)">
        {{ val.FullfillmentRate ? $n(val.FullfillmentRate * 100, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : null }}
      </div>
      <div>{{ getMarginText(val.Margin) }}</div>
      <div>{{ val.InterviewsWithoutContact }}</div>
      <div>{{ val.SentReminderEmailsWithin24hTimePeriod }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    card:               { type: Object,  default: undefined },
    mode:               { type: String,  defalut: 'monthly' },
    thresholds:         { type: Array,  required: true },
    year:               { type: Number, required: true }
  },

  methods: {
    getMonthText(month, short = false) {
      return moment({ month: month - 1 }).format(short ? 'MMM' : 'MMMM');
    },

    getColor(value) {
      if (!this.thresholds) return null;
      return this.thresholds.find(
        (thres) => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    },

    getThresholdStyle(value) {
      if (value === 0 || value > 0)
        return { background: this.getColor(value * 100) };
      return {};
    },

    getItem(count, propName, source) {
      let result = [];
      for (let i = 1; i <= count; i++) {
        let filter = {};
        filter[propName] = i;
        let item = _.find(source, filter);
        result.push(item ? item : filter);
      }
      return result;
    },

    getMonth(count, propName, source) {
      let result = [];
      for (let i = 1; i <= count; i++) {
        let filter = {};
        filter[propName] = i;
        let item = _.find(source, filter);
        result.push(item ? item : { 'Month': i });
      }
      return result;
    },

    getValue() {
      if (this.mode === 'quarterly') {
        return this.getItem(4, 'Quarter', this.card.details.quarterly.filter(x => x.Year === this.year));
      } else {
        return this.getMonth(12, 'Month', this.card.details.monthly.filter(x => x.Year === this.year));
      }
    },

    getMarginText(value){
      if (value) {
        let num = this.$n(value * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        return num.toString().replace(',', '.');
      }
      return null;
    }
  }
}
</script>

<style lang="scss" scoped>
  .lm-line, .lm-headline {
    grid-template-columns: 2fr 2fr 2fr repeat(5, 3fr) 2fr 4fr 4fr;
  }

  span {
    display: block;
  }
  
  .lm-headline {
    line-height: 1.1;
    font-size: 0.8rem;
    height: 100%;
  }
</style>